module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"login_header":"Войдите в аккаунт","by_login":"По имени пользователя","by_phone":"По номеру телефона"},"en":{"login_header":"Login to your account","by_login":"By user name","by_phone":"By phone number"}}')
  delete Component.options._Ctor
}
